import React from 'react';
import { useMutation } from '@apollo/client/react';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { ModalTypography } from 'components/styles_components/typography';
import CreateMutation from 'mutations/inspection/create';
import Form from 'components/inspection/modal/create/create_form';

const Create = ({ handleClose, onSuccess, placeId, inspectionSubjectId }) => {
  const setError = useError();

  const [createMutation, { loading }] = useMutation(CreateMutation, {
    onCompleted: ({ createInspection }) => {
      onSuccess(createInspection.inspection);
    },
    onError: () => {
      setError('error.inspection.create');
    },
  });

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.inspection.create" />
      </ModalTypography>
      <Form
        initialValues={{
          name: '',
          placeId: placeId,
          inspectionSubjectId: inspectionSubjectId,
          periodNumber: 1,
          periodCycle: 'months',
          dueDate: null,
          doneAt: null,
          notes: '',
          inspectionFields: [],
          inspectorId: null,
        }}
        processing={loading}
        onSubmit={(values) => createMutation({ variables: values })}
        onCancel={handleClose}
      />
    </>
  );
};

export default Create;
